var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/ui/components/poll_preview.tsx";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
import noop from 'lodash/noop';
import React from 'react';
import PollOption from 'soapbox/components/polls/poll-option';
import { Stack } from 'soapbox/components/ui';
import { useAppSelector } from 'soapbox/hooks';
const PollPreview = ({
  pollId
}) => {
  const poll = useAppSelector(state => state.polls.get(pollId));
  if (!poll) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Stack, {
    space: 2,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 5
    }
  }, poll.options.map((option, i) => /*#__PURE__*/React.createElement(PollOption, {
    key: i,
    poll: poll,
    option: option,
    index: i,
    showResults: false,
    active: false,
    onToggle: noop,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 9
    }
  })));
};
export default PollPreview;